import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import StyledLink from "./small-styled-link";

const Last10Js = () => {
  const data = useStaticQuery(graphql`
    query Last10JsQuery {
      allMarkdownRemark(
        limit: 10
        filter: {
          fileAbsolutePath: { regex: "/content/blog/" }
          frontmatter: { tags: { in: "JavaScript" } }
        }
        sort: { fields: frontmatter___date, order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              path
              title
            }
          }
        }
      }
    }
  `);
  const articles = data.allMarkdownRemark.edges;

  return (
    <div>
      <h3 className="text-2xl font-bold font-title">Latest JS Articles</h3>
      <ol className="list-decimal list-inside text-gray-700">
        {articles.map(({ node }) => {
          return (
            <li className="text-md" key={node.frontmatter.path}>
              <StyledLink to={node.frontmatter.path}>
                {node.frontmatter.title}
              </StyledLink>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default Last10Js;
